<app-cabecalho-esquerda [data]="data.CABECALHO"></app-cabecalho-esquerda>

<section id="funcionamentos">
    <div *ngFor="let funcionamento of data.FUNCIONAMENTOS; let index = index">
        <app-funcionamento-esquerda *ngIf="index % 2 !== 0" [data]="funcionamento"></app-funcionamento-esquerda>
        <app-funcionamento-direita *ngIf="index % 2 == 0" [data]="funcionamento"></app-funcionamento-direita>
    </div>
</section>

<section id="beneficios">
    <div *ngFor="let beneficio of data.BENEFICIOS; let index = index">
        <app-beneficio-esquerda *ngIf="index % 2 !== 0" [data]="beneficio"></app-beneficio-esquerda>
        <app-beneficio-direita *ngIf="index % 2 == 0" [data]="beneficio"></app-beneficio-direita>
    </div>
</section>

<section id="vantagens">
    <div *ngFor="let vantagem of data.VANTAGENS; let index = index">
        <app-funcionamento-esquerda *ngIf="index % 2 !== 0" [data]="vantagem"></app-funcionamento-esquerda>
        <app-funcionamento-direita *ngIf="index % 2 == 0" [data]="vantagem"></app-funcionamento-direita>
    </div>
</section>